module.exports = __webpack_public_path__ + "img/homepage.4f77bb3e.svg";